import axios from "axios";
import authHeader from '../../../authheader'

const PLSAPPLICATIONURL = process.env.REACT_APP_APIURL + "/api/IndividualPlsApplication";

const getEducationRecords = (applicationId) => {
    return axios.get(`${PLSAPPLICATIONURL}/educationrecords`, { headers: authHeader(), params:{ applicationId} });
}
const getApprovedCourseRecords = (applicationId) => {
    return axios.get(`${PLSAPPLICATIONURL}/approvedcompletedcourses`, { headers: authHeader(), params:{ applicationId} });
}
const getNonApprovedCourseRecords = (applicationId) => {
    return axios.get(`${PLSAPPLICATIONURL}/notapprovedcompletedcourses`, { headers: authHeader(), params: { applicationId } });
}
const postEducationRecord = (data) => {
    return axios.post(`${PLSAPPLICATIONURL}/educationrecord`, data, { headers: authHeader() });
}
const postApprovedCourseRecord = (data) => {
    return axios.post(`${PLSAPPLICATIONURL}/approvedcompletedcourse`, data, { headers: authHeader() });
}
const postNonApprovedCourseRecord = (data) => {
    return axios.post(`${PLSAPPLICATIONURL}/notapprovedcompletedcourse`, data, { headers: authHeader() });
}
export default {
    getEducationRecords,
    getNonApprovedCourseRecords,
    getApprovedCourseRecords,
    postEducationRecord,
    postApprovedCourseRecord,
    postNonApprovedCourseRecord
}